import React from 'react'
import { FaChevronDown } from 'react-icons/fa'

import ContactButton from '../../components/contactbutton'
import NavLink from '../../components/navlink'
import Video from '../../components/video'

const challenges = [
  <>Svårt att efterleva dagens krav på <span className="text-sky-400">säkerhet</span>?</>,
  <>Utmaningar att leverera <span className="text-sky-400">snabbt</span> nog?</>,
  <>Vilja att nå högre <span className="text-sky-400">kvalitet</span> på leverans?</>,
]

export default function HomePage() {
  return (
    <section id="home" className="relative flex min-h-[calc(100svh-4rem)] items-center overflow-hidden py-24 text-white">
      <Video />
      {/* Toning så texten alltid går att läsa ovanpå videon */}
      <div className="absolute inset-0 bg-gradient-to-r from-slate-950/90 via-slate-950/60 to-slate-950/10" />
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-slate-950/60 to-transparent" />

      <div className="container-page relative">
        <div className="flex max-w-2xl flex-col gap-8">
          <p className="eyebrow !text-sky-400">Nätverk · Automation · Systemutveckling</p>
          <h1 className="text-4xl sm:text-6xl font-semibold leading-[1.1] tracking-tight">
            Vi är <span className="text-sky-400">bäst i Sverige</span> på att designa, bygga och arbeta med <span className="text-sky-400">moderna nätverk.</span>
          </h1>

          <div className="flex flex-col gap-3 text-slate-300">
            <p className="text-lg text-white">Utmaningar med dagens krav på arkitektur?</p>
            <ul className="flex flex-col gap-1.5">
              {challenges.map((challenge, i) => (
                <li key={i} className="flex items-center gap-3">
                  <span className="h-px w-5 bg-sky-400" />
                  <span>{challenge}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-wrap items-center gap-3">
            <ContactButton>Låt oss Ace:a det tillsammans</ContactButton>
            <NavLink target="offer" className="btn-ghost">Vårt erbjudande</NavLink>
          </div>
        </div>
      </div>

      <NavLink
        target="about"
        className="absolute bottom-8 left-1/2 hidden -translate-x-1/2 text-white/60 sm:block transition-colors hover:text-white"
      >
        <FaChevronDown className="animate-bounce" size={20} aria-label="Scrolla ner" />
      </NavLink>
    </section>
  )
}
